import { customizeLiveModule } from '@nizza/customize-live';
import { collectionModule } from '@nizza/event-products';
import { CommonProviders } from '@nizza/ui';
import { StrictMode } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import 'sanitize.css/sanitize.css';
import { GlobalStyle } from 'styles/global-styles';
import 'styles/scss/theme.scss';
import { AppRouter } from './router';

// CLEAN App Modules
const modules = [collectionModule, customizeLiveModule];
const stores = modules.flatMap(module => module?.stores || []);

export const App = () => (
  <StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <CommonProviders stores={stores}>
          <Helmet titleTemplate="%s - Nizza" defaultTitle="Nizza">
            <meta name="description" content="Nizza application" />
          </Helmet>
          <AppRouter />
          <GlobalStyle />
        </CommonProviders>
      </HelmetProvider>
    </BrowserRouter>
  </StrictMode>
);
